import { render, staticRenderFns } from "./BaseAnsProps.vue?vue&type=template&id=e02547ac&scoped=true&"
import script from "./BaseAnsProps.vue?vue&type=script&lang=js&"
export * from "./BaseAnsProps.vue?vue&type=script&lang=js&"
import style0 from "./BaseAnsProps.vue?vue&type=style&index=0&id=e02547ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e02547ac",
  null
  
)

export default component.exports